import { elementExistFunction, elementsExistFunction } from "@/utils/lazy-init";
import initEstatePropertyInterest from "./EstatePropertyInterest";
import { initApplyToOpenHouseIsland } from "./AdvertApplyToOpenHouse/apply-open-house";

export default function () {
    initEstatePropertyInterest();
    initApplyToOpenHouseIsland();

    elementsExistFunction(
        [
            '[app="estate-property-search-legal-table"]',
            '[app="residences-by-property-search"]',
            '[app="active-adverts-on-property-search"]',
            '[app="related-adverts"]',
        ],
        () =>
            import("./realestate-search.lazy").then((module) =>
                module.initRealEstateSearchIslands(),
            ),
    );

    elementExistFunction('[app="poi-map"]', () =>
        import("./POIMap").then((module) => module.initPOIMapModule()),
    );

    elementExistFunction('[app="skraafoto-view"]', () =>
        import("./SkraafotoPropertyViewComponent").then((module) => module.initSkraafotoViewModule()),
    );
}
